import { combineReducers } from 'redux';
import { RootAction } from '@src/app/_redux';
import {
  INTELLISEL_ERROR,
  INTELLISEL_LOADING,
  INTELLISEL_SUCCESS,
} from './actions';

export type State = {
  readonly loading: boolean;
  intelliselOffers: {};
};

export const reducer = combineReducers<State, RootAction>({
  loading: (state = false, action) => {
    switch (action.type) {
      case INTELLISEL_SUCCESS:
      case INTELLISEL_ERROR:
        return false;
      case INTELLISEL_LOADING:
        return action.payload;
      default:
        return state;
    }
  },
  intelliselOffers: (state = {}, action) => {
    switch (action.type) {
      case INTELLISEL_SUCCESS: 
        let newpayload = {...state};
        newpayload[action.payload.transactionCode] = action.payload.response;
        return newpayload;
      default:
        return state;
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/intellisel/reducer.ts